exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "monitor-scoring .card {\n  padding: 5px; }\n  monitor-scoring .card.top-card h2 {\n    text-align: center;\n    margin: 0.2em; }\n  monitor-scoring .card .filter-section {\n    border: solid 1px silver;\n    padding: 5px 2px; }\n  monitor-scoring .card .ui-fieldset .ui-fieldset-legend {\n    padding: 3px; }\n    monitor-scoring .card .ui-fieldset .ui-fieldset-legend .ui-fieldset-toggler {\n      height: 1.5em;\n      width: 1.5em;\n      padding: 0.25em; }\n  monitor-scoring .card .ui-spinner .ui-inputtext {\n    width: 90px;\n    text-align: right;\n    padding-right: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/monitor-scoring/monitor-scoring.component.scss
// module id = ../../../../../src/app/component-module/monitor-scoring/monitor-scoring.component.scss
// module chunks = main